import { useState, useEffect } from "react";
import { Logo } from "./Logo";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { FloatingSwitchers } from "./FloatingSwitchers";

export const StickyHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToForm = () => {
    const formElement = document.getElementById("waitlist-form");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    }

    // GTM event
    if ((window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: "cta_click",
        cta_location: "header",
      });
    }
  };

  return (
    <header
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-200",
        isScrolled
          ? "bg-background/80 backdrop-blur-xl shadow-lg"
          : "bg-transparent"
      )}
      style={
        isScrolled
          ? {
              borderBottom: "3px solid transparent",
              borderImage: "linear-gradient(90deg, hsl(var(--brand-teal)), hsl(var(--brand-purple))) 1",
            }
          : undefined
      }
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between gap-4">
          {/* Logo - Show text on all screens */}
          <a href="/" className="flex items-center shrink-0">
            <Logo showText={true} />
          </a>

          {/* Right side: CTA and Switchers with responsive spacing */}
          <div className="flex items-center gap-3 md:gap-4 lg:flex-1 lg:justify-end">
            <Button
              onClick={scrollToForm}
              variant="default"
              size="sm"
            >
              {t("hero.cta")}
            </Button>
            <div className="hidden md:flex md:gap-2">
              <FloatingSwitchers />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
